import { useEffect, useRef, useState } from "react";

import { request } from "../helpers/request";
import { usePlayerStore } from "../store/usePlayerStore";

import { useSnowplowEnabled } from "./useSnowplowEnabled";

declare const __FINNPANEL_URL: string;

export const useFinnpanelEvent = () => {
  const { useStoreState } = usePlayerStore();
  const [spid, setSpid] = useState<string | undefined>(undefined);
  const ecid = useStoreState.marketingCloudVisitorId();
  const isPlaybackStarted = useStoreState.isPlaybackStarted();
  const snowplowEnabled = useSnowplowEnabled();
  const finnpanelSent = useRef(false);

  useEffect(() => {
    if (snowplowEnabled) {
      window.yleSnowplow(function () {
        // 'this' refers to the Snowplow context, but it may be undefined
        setSpid(this?.sp1?.getDomainUserId());
      });
    }
  }, [snowplowEnabled]);

  useEffect(() => {
    if (
      isPlaybackStarted &&
      ecid !== undefined &&
      spid !== undefined &&
      !finnpanelSent.current
    ) {
      const params = { ecid, spid };
      const filteredParameters = Object.keys(params).reduce(
        (acc, param) => {
          if (params[param] !== undefined) {
            acc[param] = params[param];
          }
          return acc;
        },
        {} as Record<string, string>
      );
      request({
        method: "GET",
        parameters: filteredParameters,
        url: __FINNPANEL_URL,
        useApiKeys: false
      }).catch(err => {
        console.warn("Failed to send request to finnpanel", err);
      });

      finnpanelSent.current = true;
    }
  }, [ecid, spid, isPlaybackStarted]);
};
